
export default {
  name: "SectionCargoDimensions",

  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    section: {
      type: Object,
      default: () => {
        return {}
      }
    },
    indexForm: {
      type: Number,
      default: 0
    }
  },

  computed: {
    values: function () {
      return this.form?.[this.indexForm] || {}
    }
  },

  components: {
    FormSlider: () => import("~/components/form/FormSlider.vue"),
  },

  methods: {
    changeForm: function (val, name) {
      let values = {...this.values};
      values[name] = val;

      let form = {...this.form}
      form[this.indexForm] = values;

      this.$emit('change', form);
    }
  }
}
